// limit how often a function can fire
function debounce(func, wait = 100) {
  let timeout;
  function debounced(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
  }
  // Lets a caller kill a still-pending (not yet fired) call outright — e.g.
  // when a newer, authoritative action should preempt it entirely, not just
  // outrace it once both are in flight.
  debounced.cancel = () => clearTimeout(timeout);
  return debounced;
}

function get_header_height() {
  return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
}

function disable_page_scroll() {
      
  // Get the current page scroll position
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

  // Prevent scrolling on the entire window
  window.onscroll = function() {
    window.scrollTo(scrollLeft, scrollTop);
  };

  // Add a class to the body for additional styling if needed
  document.body.classList.add('scroll-disabled');
}

function enable_page_scroll() {

  // Remove the scroll prevention
  window.onscroll = function() {};

  // Remove the class from the body
  document.body.classList.remove('scroll-disabled');
}

// Wrapper class that exempts an ACF date_picker field from the no-future-dates
// rule. Mirrors MLMP\Form_Validation::CLASS_ALLOW_FUTURE.
const ALLOW_FUTURE_CLASS = 'allow-future';

/**
 * Constrains every ACF date_picker in the form to Jan 1 - Dec 31 of
 * site_year, also capped at today (browser local date) unless the field has
 * ALLOW_FUTURE_CLASS. No-op without a valid site_year.
 *
 * @param {jQuery} $form The ACF/AF form element.
 * @param {number|string} site_year
 * @returns {void}
 */
function constrain_date_pickers($form, site_year) {
  site_year = parseInt(site_year || 0, 10);
  if (!site_year) return;

  const today = new Date();
  const year_start = new Date(site_year, 0, 1);
  const year_end = new Date(site_year, 11, 31);
  const $fields = $form.find('.acf-field[data-type="date_picker"]');

  $fields.not('.' + ALLOW_FUTURE_CLASS).find('.hasDatepicker').datepicker('option', {
    minDate: year_start,
    maxDate: today < year_end ? today : year_end,
  });
  $fields.filter('.' + ALLOW_FUTURE_CLASS).find('.hasDatepicker').datepicker('option', {
    minDate: year_start,
    maxDate: year_end,
  });
}

// Export all utilities
module.exports = {
  debounce,
  get_header_height,
  disable_page_scroll,
  enable_page_scroll,
  ALLOW_FUTURE_CLASS,
  constrain_date_pickers
};